module.exports = __webpack_public_path__ + "img/new-write-post-facebook.764cc499.jpg";